import get from "../../../get";
import {AppointmentState} from "../../../../entities/Appointment";

export const getBookingState = (slot_id: number) =>
  get<{ state: AppointmentState }>(`bookings/${slot_id}`);